import { styled } from 'src/ui/theme'

export const InlineButton = styled.button`
color: ${({ theme }) => theme.colors.brand.primary};
cursor: pointer;
font-size: 100%;
font: inherit;
`